export enum ATDLNControlType {
  CHECKBOX,
  CHECKBOX_LIST,
  CLOCK,
  DROPDOWN_LIST,
  HIDDEN,
  LABEL,
  MULTI_SELECT_LIST,
  RADIO_LIST,
  SINGLE_SELECT_LIST,
  SINGLE_SPINNER,
  SLIDER,
  TEXTFIELD,
  UNSUPPORTED,
}
